module.exports = __webpack_public_path__ + "img/no_data.535d2ede.png";